import { render } from "./allPayments.vue?vue&type=template&id=e747e7dc&scoped=true"
import script from "./allPayments.vue?vue&type=script&lang=js"
export * from "./allPayments.vue?vue&type=script&lang=js"

import "./allPayments.vue?vue&type=style&index=0&id=e747e7dc&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/itibo/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e747e7dc"]])

export default __exports__